import { Fragment, FunctionComponent } from "react";
import { Outlet } from "react-router";
import Container from "@mui/material/Container";
import Copyright from "../components/Copyright";

import Header from "./Header";

const Layout: FunctionComponent<{}> = (props) => {
  return (
    <Fragment>
      <Header />
      <Container sx={{ my: 4 }} fixed>
        <Outlet />
      </Container>
      <Copyright sx={{ my: 4 }} />
    </Fragment>
  );
};

export default Layout;
